import React from 'react'

function ServicesPost() {
  return (
    <div>
      services post component
    </div>
  )
}

export default ServicesPost
